import {getEventsListByFilters} from "../../list/utils/filterEvents";

export const isEventInFilters = (event, filtersSelected) => {
    const eventFiltered = getEventsListByFilters([event], filtersSelected);

    return !!eventFiltered.length;
};
